import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  FormLabel,
  FormControl,
  FormSelect,
} from "react-bootstrap";
import Select from "react-select";
// import { FaExchangeAlt } from "react-icons/fa";
import Header from '../../layouts/Header';

const StorageLocationStTransfer = () => {
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  
  const accessToken = localStorage.getItem("authToken");
  const [storageLocations, setStorageLocations] = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [secondaryStorageLocations, setSecondaryStorageLocations] = useState([]);
  const [formData, setFormData] = useState({
    primaryStorageLocation: "",
    secondaryStorageLocation: "",
    centralStockTransferData: [],
  });
  const [selectedRawMaterial, setSelectedRawMaterial] = useState({
    rawMaterialId: "",
    currentStockQuantity: 0,
    transferQuantity: 0,
    unit: "",
  });

  const storageLocationOptions = storageLocations.map((location) => ({
    value: location._id,
    label: `${location.name} - ${location.city}, ${location.state} `,
  }));

  const secondaryStorageLocationOptions = secondaryStorageLocations.map((location) => ({
    value: location._id,
    label: `${location.name} - ${location.city}, ${location.state} `,
  }));

  const getNewStorageLocationData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("storage-location/getCurrentStock", { headers });
      if (response?.data?.data?.storageLocations) {
        setStorageLocations(response?.data?.data?.storageLocations);
      }
    } catch (error) {
      toast.error("Failed to fetch storage location data.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const handlePrimaryStorageChange = (option) => {
    setFormData({
      ...formData,
      primaryStorageLocation: option?.value || "",
      centralStockTransferData: [],
    });

    const selectedStorage = storageLocations.find((loc) => loc._id === option?.value);
    setRawMaterials(selectedStorage?.stockInfo || []);
  };

  const handleSecondaryStorageChange = (option) => {
    setFormData({
      ...formData,
      secondaryStorageLocation: option?.value || "",
    });
  };

  const rawMaterialOptions = rawMaterials
    .filter((material) => {
      const primaryLocation = storageLocations.find(
        (loc) => loc._id === formData.primaryStorageLocation
      );
      return (
        primaryLocation &&
        primaryLocation.stockInfo.some(
          (stockItem) => stockItem.rawMaterial._id === material.rawMaterial._id
        )
      );
    })
    .map((material) => ({
      value: material.rawMaterial._id,
      label: material.rawMaterial.name,
      unit: material.rawMaterial.unit,
      currentStock: material.currentStock,
    }));

  const handleRawMaterialChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedRawMaterial({
        rawMaterialId: selectedOption.value,
        currentStockQuantity: selectedOption.currentStock,
        transferQuantity: "",
        unit: selectedOption.unit,
      });
    } else {
      setSelectedRawMaterial({
        rawMaterialId: "",
        currentStockQuantity: 0,
        transferQuantity: "",
        unit: "",
      });
    }
  };

  const handleTransferQuantityChange = (e) => {
    setSelectedRawMaterial((prev) => ({
      ...prev,
      transferQuantity: e.target.value,
    }));
  };

  const handleRawMaterialChangeInList = (selectedOption, index) => {
    const updatedTransferData = [...formData.centralStockTransferData];
    updatedTransferData[index].rawMaterialId = selectedOption ? selectedOption.value : "";
    setFormData((prev) => ({
      ...prev,
      centralStockTransferData: updatedTransferData,
    }));
  };

  const handleCurrentStockQuantityChangeInList = (e, index) => {
    const updatedTransferData = [...formData.centralStockTransferData];
    updatedTransferData[index].currentStockQuantity = e.target.value;
    setFormData((prev) => ({
      ...prev,
      centralStockTransferData: updatedTransferData,
    }));
  };

  const handleUnitChangeInList = (e, index) => {
    const updatedTransferData = [...formData.centralStockTransferData];
    updatedTransferData[index].unit = e.target.value;
    setFormData((prev) => ({
      ...prev,
      centralStockTransferData: updatedTransferData,
    }));
  };

  const addToTransferList = () => {
    if (selectedRawMaterial.rawMaterialId && selectedRawMaterial.transferQuantity > 0) {
      setFormData((prev) => ({
        ...prev,
        centralStockTransferData: [...prev.centralStockTransferData, selectedRawMaterial],
      }));
      setSelectedRawMaterial({
        rawMaterialId: "",
        currentStockQuantity: 0,
        transferQuantity: 0,
        unit: "",
      });
    } else {
      toast.error("Please select a material and enter a valid quantity.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.post("/stock-transactions/stockTransferBetweenStorageLocations", formData, { headers });
      if (response?.data?.status === true) {
        toast.success("Stock transfer successful!", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        setFormData({
          primaryStorageLocation: "",
          secondaryStorageLocation: "",
          centralStockTransferData: [],
        });

        setSelectedRawMaterial({
          rawMaterialId: "",
          currentStockQuantity: 0,
          transferQuantity: 0,
          unit: "",
        });

        getNewStorageLocationData();
      }
    } catch (error) {
      let errorMessage = '';
      if (error.response?.status === 406) {
        errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
      }
      else if (error.response?.status === 412) {
        errorMessage = error?.response?.data?.error;
      } else if (error.response?.status === 500) {
        errorMessage = error?.response?.data?.error
      }
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const fetchSecondaryStorageLocations = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      const response = await axios.get("storage-location", { headers });
      if (response?.data?.status === true) {
        setSecondaryStorageLocations(response?.data?.data?.storageLocations);
      }
    } catch (error) {
      console.error("Error fetching secondary storage locations:", error);
    }
  };

  useEffect(() => {
    getNewStorageLocationData();
    fetchSecondaryStorageLocations();
  }, []);

  const handleTransferQuantityChangeInList = (e, index) => {
    const updatedTransferData = [...formData.centralStockTransferData];
    updatedTransferData[index].transferQuantity = e.target.value;
    setFormData((prev) => ({
      ...prev,
      centralStockTransferData: updatedTransferData,
    }));
  };

  const handleRemoveFromList = (index) => {
    const updatedTransferData = formData.centralStockTransferData.filter(
      (_, i) => i !== index
    );
    setFormData((prev) => ({
      ...prev,
      centralStockTransferData: updatedTransferData,
    }));
  };

  return (
    <React.Fragment>
        <Header onSkin={setSkin} />
        <div className="main main-app p-3 p-lg-4">
            <Card>
                <Card.Header className="bg-primary text-white d-flex align-items-center p-3">
                    <i className="bi bi-arrow-left-right fs-5 me-2"></i>
                    STORAGE LOCATION STOCK TRANSFER
                </Card.Header>

                {/* Storage Location Selection */}
                <Card.Body className="p-4">
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-4">
                            <Col md={6}>
                            <FormLabel className="fw-semibold">
                                From: Primary Storage Location <span className="text-danger">*</span>
                            </FormLabel>
                            <Select
                                isClearable
                                options={storageLocationOptions.filter(
                                (loc) => loc.value !== formData.secondaryStorageLocation
                                )}
                                onChange={handlePrimaryStorageChange}
                                value={storageLocationOptions.find(
                                (option) => option.value === formData.primaryStorageLocation
                                )}
                                placeholder="Select Primary Storage Location"
                                isDisabled={formData.centralStockTransferData.length > 0}
                            />
                            </Col>
                            <Col md={6}>
                            <FormLabel className="fw-semibold">
                                To: Secondary Storage Location <span className="text-danger">*</span>
                            </FormLabel>
                            <Select
                                isClearable
                                options={secondaryStorageLocationOptions.filter(
                                (loc) => loc.value !== formData.primaryStorageLocation
                                )}
                                onChange={handleSecondaryStorageChange}
                                value={secondaryStorageLocationOptions.find(
                                (option) => option.value === formData.secondaryStorageLocation
                                )}
                                placeholder="Select Secondary Storage Location"
                                isDisabled={formData.centralStockTransferData.length > 0}
                            />
                            </Col>
                        </Row>

                        <hr />

                        {/* Raw Material Selection and Quantity Input */}
                        <Row className="mb-4">
                            <Col md={6}>
                            <FormLabel className="fw-semibold">
                                Raw Material <span className="text-danger">*</span>
                            </FormLabel>
                            <Select
                                isClearable
                                options={rawMaterialOptions.filter((option) =>
                                !formData.centralStockTransferData.some(
                                    (item) => item.rawMaterialId === option.value
                                )
                                )}
                                onChange={handleRawMaterialChange}
                                value={rawMaterialOptions.find(
                                (option) => option.value === selectedRawMaterial.rawMaterialId
                                )}
                                placeholder="Select Raw Material"
                            />
                            </Col>
                            <Col md={2}>
                            <FormLabel className="fw-semibold">Current Stock</FormLabel>
                            <FormControl
                                disabled
                                type="text"
                                value={
                                selectedRawMaterial.currentStockQuantity !== null && selectedRawMaterial.currentStockQuantity !== undefined
                                    ? `${selectedRawMaterial.currentStockQuantity} ${selectedRawMaterial.unit || ""}`
                                    : "0"
                                }
                            />
                            </Col>
                            <Col md={2}>
                            <FormLabel className="fw-semibold">
                                Transfer Quantity <span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                type="number"
                                min="0"
                                value={selectedRawMaterial.transferQuantity}
                                onChange={handleTransferQuantityChange}
                            />
                            </Col>
                            <Col md={2} className="d-flex align-items-end">
                            <Button variant="primary" onClick={addToTransferList} size="sm">
                                + Add
                            </Button>
                            </Col>
                        </Row>

                        <hr />

                        {/* Transfer List Section */}
                        <div className="mb-4">
                            <h6 className="fw-bold mb-3">Transfer List</h6>
                            {formData.centralStockTransferData.length === 0 ? (
                            <div className="text-muted text-center py-4">
                                No items added to the transfer list yet.
                            </div>
                            ) : (
                            formData.centralStockTransferData.map((item, index) => {
                                const selectedRawMaterial = rawMaterials.find(
                                (material) => material.rawMaterial._id === item.rawMaterialId
                                );

                                return (
                                <div
                                    key={index}
                                    className="mb-3 p-3"
                                    style={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    <Row className="align-items-center">
                                    <Col md={4}>
                                        <FormLabel className="fw-semibold">Raw Material</FormLabel>
                                        <Select
                                        value={selectedRawMaterial ? { value: selectedRawMaterial.rawMaterial._id, label: selectedRawMaterial.rawMaterial.name } : null}
                                        onChange={(selectedOption) => handleRawMaterialChangeInList(selectedOption, index)}
                                        options={rawMaterials.map((material) => ({
                                            value: material?.rawMaterial?._id,
                                            label: material?.rawMaterial?.name,
                                            isDisabled: formData.centralStockTransferData.some(item => item.rawMaterialId === material?.rawMaterial?._id)
                                        }))}
                                        isClearable
                                        placeholder="Select Raw Material"
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <FormLabel className="fw-semibold">Current Stock</FormLabel>
                                        <FormControl
                                        type="text"
                                        disabled
                                        value={selectedRawMaterial ? `${selectedRawMaterial.currentStock?.toFixed(2)} ${selectedRawMaterial.rawMaterial.unit}` : "0"}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <FormLabel className="fw-semibold">Unit</FormLabel>
                                        <FormControl
                                        type="text"
                                        value={item.unit}
                                        disabled
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <FormLabel className="fw-semibold">Transfer Quantity</FormLabel>
                                        <FormControl
                                        step="any"
                                        type="number"
                                        value={item.transferQuantity}
                                        onChange={(e) => handleTransferQuantityChangeInList(e, index)}
                                        />
                                    </Col>
                                    <Col md={2} className="d-flex align-items-center">
                                        <Button
                                        size="sm"
                                        className="mt-4"
                                        variant="danger"
                                        onClick={() => handleRemoveFromList(index)}
                                        >
                                        Remove
                                        </Button>
                                    </Col>
                                    </Row>
                                </div>
                                );
                            })
                            )}
                        </div>

                        {/* Submit Button */}
                        <div className="d-flex justify-content-end">
                            <Button variant="success" className="fw-semibold" type="submit">
                            Submit Transfer
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    </React.Fragment>
  );
};

export default StorageLocationStTransfer;